import { useMutation, useQuery } from "@tanstack/react-query";
import assetRepository from "../../infra/repositories/asset-repository";

export const useAssetUrl = (fileKey: string | null, enabled: boolean = true) => {
  return useQuery({
    queryKey: ["asset-url", fileKey],
    queryFn: async () => {
      if (!fileKey) return null;
      const res = await assetRepository.getAssetUrl(fileKey);
      return res.url;
    },
    enabled: enabled && !!fileKey,
    staleTime: 1000 * 60 * 10, // 10 minutos de cache
  });
};

export const useUploadAssetMutation = () => {
  return useMutation({
    mutationFn: async ({ folder, file }: { folder: string; file: File }) => {
      return await assetRepository.uploadAsset(folder, file);
    },
  });
};
